module.exports = __webpack_public_path__ + "img/kh17.dcbdd8cb.png";